import axios from "../../axios";

const getServicesByStylist = async (stylist_id) => {
  try {
    if (!stylist_id) return [];

    const { data } = await axios.get(`/services/stylist/${stylist_id}`);
    console.log(data?.rows, "service rows");
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const getServicesByStylists = async () => {
  try {
    const { data } = await axios.get(`/services/by_stylists`);
    console.log(data, "service rows");
    return data;
  } catch (e) {
    return null;
  }
};

const getRepairFollowUps = async (customer_id) => {
  try {
    const { data } = await axios.get(`/repair_tickets/follow_ups/${customer_id}`);
    return data;
  } catch (e) {
    return null;
  }

};

export { getServicesByStylist, getRepairFollowUps, getServicesByStylists };